import { memo } from 'react';

import { Navigate, useLocation, useParams } from '@/js/libs/router';

interface LegacyPathRedirectProps {
  to: string;
}

/**
 * Redirects a bookmarked URL of a section that moved, keeping whatever followed the moved
 * prefix — a bookmarked `settings/websites/12/history` lands on `/company-settings/websites/12/history`.
 */
const LegacyPathRedirect = ({ to }: LegacyPathRedirectProps) => {
  const params = useParams();
  const { search, hash, state } = useLocation();

  const rest = params['*'];
  const path = rest ? `${to}/${rest}` : to;

  return <Navigate to={`${path}${search}${hash}`} state={state} replace />;
};

export default memo(LegacyPathRedirect);
